var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_732_18723)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9401 7.94015C11.2214 7.65924 11.6026 7.50146 12.0001 7.50146C12.3976 7.50146 12.7789 7.65924 13.0601 7.94015L18.7181 13.5961C18.8574 13.7355 18.9678 13.9009 19.0432 14.0829C19.1185 14.2649 19.1573 14.46 19.1573 14.657C19.1572 14.854 19.1184 15.0491 19.0429 15.231C18.9675 15.413 18.857 15.5784 18.7176 15.7176C18.5783 15.8569 18.4129 15.9674 18.2309 16.0427C18.0489 16.1181 17.8538 16.1568 17.6568 16.1568C17.4598 16.1567 17.2647 16.1179 17.0827 16.0424C16.9007 15.967 16.7354 15.8565 16.5961 15.7171L12.0001 11.1211L7.40412 15.7171C7.26582 15.8605 7.10036 15.9748 6.91739 16.0535C6.73442 16.1322 6.53761 16.1737 6.33844 16.1755C6.13928 16.1773 5.94174 16.1395 5.75736 16.0641C5.57298 15.9888 5.40545 15.8775 5.26455 15.7367C5.12364 15.596 5.01218 15.4285 4.93668 15.2442C4.86117 15.0599 4.82312 14.8624 4.82476 14.6633C4.82639 14.4641 4.86768 14.2672 4.94621 14.0842C5.02473 13.9012 5.13893 13.7356 5.28212 13.5971L10.9391 7.93915L10.9401 7.94015Z",
    fill: "#314450"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_732_18723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChevronUp);
export default __webpack_public_path__ + "static/media/Ic_chevron--up.30dd323667a83a3eac59e0608e477049.svg";
export { ForwardRef as ReactComponent };